import { useMemo } from 'react';

// Try to load version info synchronously at module load time
let versionData = {
  version: 'development',
  buildTimestamp: null,
  build: null
};

try {
  // This will be resolved at build time by webpack
  const versionModule = require('../version.json');
  versionData = versionModule;
} catch (error) {
  console.warn('Version file not available, using development defaults');
}

export const useVersion = () => {
  return useMemo(() => versionData, []);
};